import { useKioskStore } from '@/stores/kiosk';
import { useEffect, useState } from 'react';

const KIOSK_APPOINTMENTS_POLL_INTERVAL = 10 * 1000; // 10 seconds in ms

/**
 * This hook is responsible for periodically fetching the kiosk appointments.
 * It calls the getAppointmentsKiosk function from the kiosk store every 10 seconds.
 * This ensures that the kiosk has the most up-to-date information about the appointments,
 * which is crucial for controlling access to the kiosk based on active appointments.
 * The hook also fetches the appointments immediately when it is mounted to ensure that
 * the data is available as soon as possible.
 * @returns The loading state indicating whether appointments are being fetched.
 */
export const useAppointmentKioskFetch = () => {
  const [loading, setLoading] = useState(true);
  const getAppointmentsKiosk = useKioskStore(
    (state) => state.getAppointmentsKiosk,
  );

  useEffect(() => {
    const callback = async () => {
      try {
        await getAppointmentsKiosk();
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    void callback();
  }, [getAppointmentsKiosk]);

  useEffect(() => {
    const interval = setInterval(
      () => getAppointmentsKiosk(),
      KIOSK_APPOINTMENTS_POLL_INTERVAL,
    );

    return () => {
      clearInterval(interval);
    };
  }, [getAppointmentsKiosk]);

  return loading;
};
